import React from 'react';
import { useMutation } from '@apollo/client';
import TrackerRemoveMealMutation from './TrackerRemoveMealMutation';
import TrackerQuery from '../Fetch/TrackerQuery';

interface ITrackerRemoveMealConnectorApolloProps {
  children: ({
    removeMeal,
  }: {
    removeMeal: (mealId: number) => Promise<any>;
  }) => React.ReactElement;
  date: string;
}

const TrackerRemoveMealConnectorApollo: React.FC<ITrackerRemoveMealConnectorApolloProps> = ({
  children,
  date,
}) => {
  const [removeMealMutation] = useMutation(TrackerRemoveMealMutation, {
    awaitRefetchQueries: true,
    refetchQueries: [
      {
        query: TrackerQuery,
        variables: {
          date,
        },
      },
    ],
  });

  const removeMeal = async (mealId: number) => {
    const response = await removeMealMutation({
      variables: { mealId },
    });

    return response.data.dailyTracker.removeMeal;
  };
  return children({ removeMeal });
};

export default TrackerRemoveMealConnectorApollo;
